@if (formWrapper().form(); as form) {
  <hau-form [formGroup]="form">
    <hau-form-field label="Bezeichnung" [validation]="form.validation.name" cols="12">
      <input fullWidth type="text" nbInput [formControl]="form.controls.name">
    </hau-form-field>
    <hau-form-field label="Prüfpunktnummer" [validation]="form.validation.number" cols="6">
      <input fullWidth type="text" nbInput [formControl]="form.controls.number">
    </hau-form-field>
    <hau-form-field label="Gruppe" [validation]="form.validation.checkpointGroupId" cols="6">
      <wr-checkpoint-group-select [tenantId]="currentTenantId()" formControlName="checkpointGroupId"></wr-checkpoint-group-select>
    </hau-form-field>
    <hau-form-field label="Gewichtung" [validation]="form.validation.weight" cols="6">
      <input fullWidth type="number" nbInput [formControl]="form.controls.weight" min="0" max="10">
    </hau-form-field>
    <hau-form-field label="Externe Firmen" [validation]="form.validation.contractors" cols="6">
      <wr-tenant-multi-select [tenantType]="TenantTypeEnum.Contractor" formControlName="contractors"></wr-tenant-multi-select>
    </hau-form-field>
    <hau-form-field label="Überholt" cols="6">
      <nb-toggle formControlName="deprecated"></nb-toggle>
    </hau-form-field>
    <hau-form-field label="Hat TGA?" cols="6">
      <nb-toggle formControlName="buildingEquipmentRelated"></nb-toggle>
    </hau-form-field>
    <hau-form-field label="Beschreibung" [validation]="form.validation.description">
      <textarea fullWidth nbInput [formControl]="form.controls.description"></textarea>
    </hau-form-field>
  </hau-form>
}
